import { render, staticRenderFns } from "./permision-detail.vue?vue&type=template&id=6033e44c&scoped=true&"
import script from "./permision-detail.vue?vue&type=script&lang=ts&"
export * from "./permision-detail.vue?vue&type=script&lang=ts&"
import style0 from "./permision-detail.vue?vue&type=style&index=0&id=6033e44c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033e44c",
  null
  
)

export default component.exports